import React from 'react';
import './Static.css';

const Vision = () => {
  return (
    <div>
      <h2>The vision is that every eligible voter thinks critically and votes!</h2>
    </div>
  )
}

export default Vision;



// WEBPACK FOOTER //
// ./src/components/staticComponents/Vision.js